import {
  getNextOnboardingStep,
  profileValidations,
  onboardingStepsCompleted,
  onboardingStepsRequired
} from "./WebsiteValidator";
import {Link} from "react-router-dom";
import React, {useContext} from "react";
import {ProviderProfileContext} from "../../ProviderProfileProvider";

export const ProviderHomeBanner = () => {

  const {business, businessProfile} = useContext(ProviderProfileContext);

  const nextOnboardingStep = getNextOnboardingStep(business, businessProfile);

  // If the business is published, there's no onboarding steps to show.
  if (business?.published) {
    return <></>;
  }

  if (nextOnboardingStep.stepNumber >= 0 && nextOnboardingStep.step) {

    const stepsCompleted = onboardingStepsCompleted(business, businessProfile);
    const stepsRequired = onboardingStepsRequired(business, businessProfile);
    
    return <div className={'OnboardingBanner'}>
      You've completed {stepsCompleted}/{stepsRequired} onboarding steps. Next:&nbsp;
      <Link to={nextOnboardingStep.step.link}>{nextOnboardingStep.step.issues(business, businessProfile)[0]}</Link>
    </div>

  } else {
    return <div className={'OnboardingBanner'}>
      <b>Congratulations — your checklist is complete!</b>&nbsp;
      Visit the <Link style={{textDecoration: 'underline'}} to={'/home/publishing'}>Publishing page
    </Link> to preview your profile and go live.
      <br/><br/>
      Be sure to <b>preview your changes</b> before clicking <b>“Publish.”</b> Once published, your updates will be
      live on the Kensu platform.
    </div>
  }
};
